import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { clsxm } from '../utils';

/**
 * Makes a whole table cell (padding included) one click target, so a `rowHref` /
 * `childRowHref` row is clickable edge-to-edge rather than only over its text. The negative
 * margins cancel the cell's padding and the padding re-adds it inside the link; `h-full` lets
 * an empty cell (a leading indent or filler) still fill the row height.
 *
 * Under `inset={false}` the outer cells drop their outer padding (`first:pl-0 last:pr-0` on
 * `TableCell`), so the wrapper drops the matching negation on that edge — the caller passes
 * `isFirst` / `isLast` because a link is always the sole child of its cell and so can't detect
 * its cell's position itself.
 */
export function LinkCell(t0) {
  const $ = _c(7);
  const {
    href,
    inset,
    isFirst,
    isLast,
    children
  } = t0;
  const t1 = !inset && isFirst && "ml-0 pl-0";
  const t2 = !inset && isLast && "mr-0 pr-0";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = clsxm("block h-full -mx-2 -my-4 px-2 py-4", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== href || $[5] !== t3) {
    t4 = <Link className={t3} href={href}>{children}</Link>;
    $[3] = children;
    $[4] = href;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}